import React__default from 'react';
import { C as ChannelProvider } from './ChannelProvider-d5126903.js';
import ChannelUI from './Channel/components/ChannelUI.js';
import './UserProfileContext-daa99f9b.js';
import 'prop-types';
import './useSendbirdStateContext.js';
import './withSendBird.js';
import './_rollupPluginBabelHelpers-8e4fae98.js';
import './index-4a59a866.js';
import './index-353f13f3.js';
import './topics-17d99dd6.js';
import './index-ad4c9e58.js';
import './tslib.es6-83aa13f5.js';
import './compareIds-48d87cc5.js';
import './const-3f63e129.js';
import './uuid-6d14d007.js';
import './ui/ContextMenu.js';
import './index-a611bd38.js';
import './stringSet-91746bf1.js';
import 'react-dom';
import './ui/SortByRow.js';
import './ui/ReactionButton.js';
import './ui/ImageRenderer.js';
import './ui/Icon.js';
import './index-303a3b6e.js';
import './ui/Loader.js';
import './LocalizationContext-b021af8f.js';
import './ui/ConnectionStatus.js';
import './Channel/components/ChannelHeader.js';
import './ui/IconButton.js';
import './ui/ChannelAvatar.js';
import './ui/Avatar.js';
import './utils-7d39b941.js';
import './Channel/components/MessageList.js';
import './index-f119413c.js';
import './Channel/components/Message.js';
import './Channel/components/SuggestedMentionList.js';
import './const-09c22c50.js';
import './ui/DateSeparator.js';
import './color-2863fbbe.js';
import './ui/MessageInput.js';
import 'stream';
import './index-41a6f4f2.js';
import './ui/MentionUserLabel.js';
import './ui/MessageContent.js';
import './ui/UserProfile.js';
import './sendBirdSelectors.js';
import './ui/MessageStatus.js';
import './ui/MessageItemMenu.js';
import './ui/MessageItemReactionMenu.js';
import './ui/EmojiReactions.js';
import './ui/Tooltip.js';
import './ui/TooltipWrapper.js';
import './ui/ReactionBadge.js';
import './ui/AdminMessage.js';
import './ui/TextMessageItemBody.js';
import './index-4889e530.js';
import './ui/LinkLabel.js';
import './ui/FileMessageItemBody.js';
import './ui/TextButton.js';
import './ui/ThumbnailMessageItemBody.js';
import './ui/OGMessageItemBody.js';
import './ui/UnknownMessageItemBody.js';
import './ui/QuoteMessage.js';
import './Channel/components/FileViewer.js';
import './index-1fd114b0.js';
import './Channel/components/RemoveMessageModal.js';
import './ui/Modal.js';
import './utils-9ef11656.js';
import './Channel/components/TypingIndicator.js';
import './Channel/components/FrozenNotification.js';
import './Channel/components/UnreadCount.js';
import './Channel/components/MessageInput.js';
import './ui/QuoteMessageInput.js';

var Channel = function Channel(props) {
  return /*#__PURE__*/React__default.createElement(ChannelProvider, {
    channelUrl: props === null || props === void 0 ? void 0 : props.channelUrl,
    useMessageGrouping: props === null || props === void 0 ? void 0 : props.useMessageGrouping,
    useReaction: props === null || props === void 0 ? void 0 : props.useReaction,
    showSearchIcon: props === null || props === void 0 ? void 0 : props.showSearchIcon,
    highlightedMessage: props === null || props === void 0 ? void 0 : props.highlightedMessage,
    startingPoint: props === null || props === void 0 ? void 0 : props.startingPoint,
    onBeforeSendUserMessage: props === null || props === void 0 ? void 0 : props.onBeforeSendUserMessage,
    onBeforeSendFileMessage: props === null || props === void 0 ? void 0 : props.onBeforeSendFileMessage,
    onBeforeUpdateUserMessage: props === null || props === void 0 ? void 0 : props.onBeforeUpdateUserMessage,
    onChatHeaderActionClick: props === null || props === void 0 ? void 0 : props.onChatHeaderActionClick,
    onSearchClick: props === null || props === void 0 ? void 0 : props.onSearchClick,
    replyType: props === null || props === void 0 ? void 0 : props.replyType,
    queries: props === null || props === void 0 ? void 0 : props.queries,
    renderUserProfile: props === null || props === void 0 ? void 0 : props.renderUserProfile,
    disableUserProfile: props === null || props === void 0 ? void 0 : props.disableUserProfile
  }, /*#__PURE__*/React__default.createElement(ChannelUI, {
    renderPlaceholderLoader: props === null || props === void 0 ? void 0 : props.renderPlaceholderLoader,
    renderPlaceholderInvalid: props === null || props === void 0 ? void 0 : props.renderPlaceholderInvalid,
    renderPlaceholderEmpty: props === null || props === void 0 ? void 0 : props.renderPlaceholderEmpty,
    renderChannelHeader: props === null || props === void 0 ? void 0 : props.renderChannelHeader,
    renderMessage: props === null || props === void 0 ? void 0 : props.renderMessage,
    renderMessageInput: props === null || props === void 0 ? void 0 : props.renderMessageInput,
    renderTypingIndicator: props === null || props === void 0 ? void 0 : props.renderTypingIndicator,
    renderCustomSeperator: props === null || props === void 0 ? void 0 : props.renderCustomSeperator
  }));
};

export { Channel as default };